import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'
import UpdateTransactionSuccessDialog from './UpdateTransactionSuccessDialog'

export const DIALOG_NAME = 'pass-through-transaction-success'

const mapStateToProps = null

const mapDispatchToProps = {
  handleClose: aCloseDialog,
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTransactionSuccessDialog)
